export const GlobalVariable = Object.freeze({
  // prod
  // BASE_API_URL: 'https://app_bsicpay.bsicbank.bj/clk',
  // BASE_MEDIA_URL: 'https://app_bsicpay.bsicbank.bj/',
  // PUBLIC_API_URL: 'https://app_bsicpay.bsicbank.bj/public',
  // BASE_COLLECT_API_URL: 'https://app_bsicpay.bsicbank.bj/collect/clk',

  // test

  // BASE_API_URL: 'https://app.test.bsicash.bsicbank.bj/clk',
  // BASE_MEDIA_URL: 'https://app.test.bsicash.bsicbank.bj/',
  // PUBLIC_API_URL: 'https://app.test.bsicash.bsicbank.bj/public',
  // BASE_COLLECT_API_URL: 'https://app.test.bsicash.bsicbank.bj/collect/clk',

  // dev
  BASE_API_URL: 'https://app.dev.bsicash.bsicbank.bj/clk',
  BASE_MEDIA_URL: 'https://app.dev.bsicash.bsicbank.bj/',
  PUBLIC_API_URL: 'https://app.dev.bsicash.bsicbank.bj/public',
  BASE_COLLECT_API_URL: 'https://app.dev.bsicash.bsicbank.bj/collect/clk',

  AIRTIME_PROVIDER : [],
  COLLECTION_API: [],
  SMS_PROVIDERS: ['WIREPICK'],
  WHATSAPP_MESSAGE_PROVIDER: [],
  PASSWORD_MAX_AGE: 30,
  CUSTOMER_ID_TYPES: ['CI', 'CE', 'PA', 'PC', 'NONE'],
  DEBUG_REQUESTS_MODE: false,
  MINIMUM_CREDIT_OPERATION_AMOUNT: 10,
  MINIMUM_DEBIT_OPERATION_AMOUNT: 10,
  MINIMUM_TRANSFER_OPERATION_AMOUNT: 10,
  MINIMUM_CREDIT_DEPOSITACCOUNTOPERATION_AMOUNT: 10,
  MINIMUM_DEBIT_DEPOSITACCOUNTOPERATION_AMOUNT: 10,
  MINIMUM_PAYEMENT_DEPOSITACCOUNTOPERATION_AMOUNT: 10,
  MINIMUM_CASHOUT_OPERATION_AMOUNT : 10,
  MINIMUM_COLLECT_PRODUCT_AMOUNT: 10,
  TEST_MODE: true
});



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/global.ts